<div class="upload-file-container pt-2 mb-4">
  <div class="selector-div-wrapper mb-2">
    <span><small>Mostrar</small></span>
    <!-- <div class="selector-div">
      <select name="selector" class="selector" [(ngModel)]="tool.enabled">
        <option [ngValue]="true">Si</option>
        <option [ngValue]="false">No</option>
      </select>
      <div class="vertical-line"></div>
    </div> -->
    <div class="form-check form-switch">
      <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="externalbtn-switch"
        [(ngModel)]="tool.enabled" [checked]="tool.enabled">
      <!-- <label class="form-check-label" for="externalbtn">Checked switch checkbox input</label> -->
    </div>
  </div>
  <div class="title-container mb-3" *ngIf="tool.enabled">
    <span class="title">Nombre del botón</span>
    <input class="custom-input" type="text" [(ngModel)]="tool.text">
  </div>
  <div class="title-container" *ngIf="tool.enabled">
    <p>Enlace del botón</p>
    <input class="custom-input" type="text" [(ngModel)]="tool.link">
  </div>
  <div class="color-selector-row mt-2 mb-2">
    <div>
      <span class="me-3">Color fondo:</span>
    </div>
    <div>
      <input class="colorpicker-input" [(ngModel)]="colors.background" [value]="colors.background"
        [style.background]="colors.background" [(colorPicker)]="colors.background">
    </div>
  </div>
  <div class="color-selector-row mb-2">
    <div>
      <span class="me-3">Color text:</span>
    </div>
    <div>
      <input class="colorpicker-input" [(ngModel)]="colors.text" [value]="colors.text" [style.background]="colors.text"
        [(colorPicker)]="colors.text">
    </div>
  </div>
</div>